export const addMonths = (date: Date, months: number) => {
    const dt = new Date(date);
    dt.setMonth(dt.getMonth() + months);
    return dt;
};
